import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'grid-ui-cell-renderer-subscribed',
  templateUrl: './cell-renderer-subscribed.component.html',
  styleUrl: './cell-renderer-subscribed.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.CellRendererSubscribed]': 'true',
  },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererSubscribedComponent implements ICellRendererAngularComp {
  public subscribed: boolean;

  public agInit({ node }: ICellRendererParams): void {
    this.subscribed = !node.data.restricted;
  }

  public refresh(): boolean {
    return false;
  }
}
